var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.528 0H7.472C3.104 0 0.5 2.604 0.5 6.972V17.028C0.5 21.396 3.104 24 7.472 24H17.528C21.896 24 24.5 21.396 24.5 17.028V6.972C24.5 2.604 21.896 0 17.528 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.072 8.24399C20.072 8.73599 19.676 9.14399 19.172 9.14399H12.872C12.38 9.14399 11.972 8.73599 11.972 8.24399C11.972 7.75199 12.38 7.34399 12.872 7.34399H19.172C19.676 7.34399 20.072 7.75199 20.072 8.24399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.064 7.08012L7.364 9.78012C7.184 9.96012 6.956 10.0441 6.728 10.0441C6.5 10.0441 6.26 9.96012 6.092 9.78012L5.192 8.88012C4.832 8.53212 4.832 7.95612 5.192 7.60812C5.54 7.26012 6.104 7.26012 6.464 7.60812L6.728 7.87212L8.792 5.80812C9.14 5.46012 9.704 5.46012 10.064 5.80812C10.412 6.15612 10.412 6.73212 10.064 7.08012Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.072 16.6439C20.072 17.1359 19.676 17.5439 19.172 17.5439H12.872C12.38 17.5439 11.972 17.1359 11.972 16.6439C11.972 16.1519 12.38 15.7439 12.872 15.7439H19.172C19.676 15.7439 20.072 16.1519 20.072 16.6439Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.064 15.48L7.364 18.18C7.184 18.36 6.956 18.444 6.728 18.444C6.5 18.444 6.26 18.36 6.092 18.18L5.192 17.28C4.832 16.932 4.832 16.356 5.192 16.008C5.54 15.66 6.104 15.66 6.464 16.008L6.728 16.272L8.792 14.208C9.14 13.86 9.704 13.86 10.064 14.208C10.412 14.556 10.412 15.132 10.064 15.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSquare);
export default __webpack_public_path__ + "static/media/task-square.f23749755e384b1117aed945229beb4b.svg";
export { ForwardRef as ReactComponent };